var map = {
	"./img_0.png": 20151,
	"./img_1.jpg": 30632,
	"./img_2.jpg": 8861,
	"./img_3.jpg": 87157,
	"./img_4.jpg": 44590,
	"./img_5.jpg": 19732,
	"./img_6.jpg": 91925,
	"./img_7.jpg": 94450,
	"./img_8.jpg": 68191,
	"./img_9.webp": 75517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1665;